"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IComponent.js.map